import { SALARY_CALCULATION_OPTIONS } from 'cpool-constants';
import { z } from 'zod';

import { schemaBigDecimal } from '../../utils/schema.utils';

export const schemaDataSnippets = z.object({
    excludeApplicant: z.boolean().nullish().default(false),
    rentFree: z.boolean().nullish().default(false),
    salary: schemaBigDecimal.nullish(),
    salaryMode: z
        .nativeEnum(SALARY_CALCULATION_OPTIONS)
        .optional()
        .default(SALARY_CALCULATION_OPTIONS.LAST_MONTHS_SALARY),
    withoutMaintenanceIncome: z.boolean().nullish().default(false),
    withoutOtherIncome: z.boolean().nullish().default(false),
    withoutRentIncome: z.boolean().nullish().default(false),
    withoutSidejob: z.boolean().nullish().default(false),
});

export type SchemaDataSnippets = z.infer<typeof schemaDataSnippets>;
// trigger build process
